export default __webpack_public_path__ + "static/Event5-f6e9c26aa8ba52e7b8546e8944f5270b.jpg";